import Image from 'app/Components/Shared/Image/image';
/*
  This component was copied from Aviv's Otp Component
  and modified for authentication purpose
*/

import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import { Container, Row, Col } from 'reactstrap';
import TextInput from '../TextInput/TextInput';
import { getRecaptchaToken } from '../../../utilities/recaptcha/recaptcha';
import { showAppLoader, hideAppLoader } from '../Loader/LoaderSlice';
import BtnSubmit from '../Buttons/BtnSubmit';
import { validateFields, validateField } from '../../../utilities/validation/validator';
import { regexPatterns } from '../../../utilities/validation/validationVariables';
import { connect } from 'react-redux';
import ProviderManager from '../../../provider/providerManager';
import Config from '../../../Config';
import OtpInput from 'react-otp-input';
import { otpReportStep } from './otpSlice';
import { createOtpLogin, validateOtpLogin } from '../../../utilities/authentication/authenticationSlice';

const LoginOtp = (props) => {
  const [wrongOtpMessage, setWrongOtpMessage] = useState('');
  const [otpTicketId, setOtpTicketId] = useState('');

  const [form, setForm] = useState({
    phone: '',
    id: '',
    verifyCode: '',
    numOfAttempts: 0,
    errors: {},
    rules: {
      verifyCode: {
        required: { value: true, error: 'לא הוזן קוד' },
        minLength: {
          value: 6,
          error: 'יש להזין 6 תווים',
        },
        pattern: {
          value: regexPatterns.numbersRegex,
          error: 'ערך לא תקין',
        },
      },
    },
  });

  useExtendedEffect(
    (runSideEffects) => {
      if (!runSideEffects()) {
        if (props.currentStep == 1) {
          clearCode();
          clearPhone();
          setOtpTicketId('');
        }
      }
    },
    [props.currentStep]
  );

  useEffect(() => {
    if ('OTPCredential' in window) {
      async function fetchOtp() {
        try {
          const otp = await navigator.credentials.get({
            otp: { transport: ['sms'] },
          });
          if (otp?.code) {
            handleCodeChange(otp.code);
          }
        } catch (err) {
          console.error('Error fetching OTP:', err);
        }
      }
      fetchOtp();
    }
  }, []);

  // step 1 ------------------------------------------------------------------

  const getTicket = async () => {
    if (validateStep1(form)) {
      const step1Ticket = await createOtpStep1();
      if (step1Ticket && step1Ticket != '') {
        setOtpTicketId(step1Ticket);
        props.otpReportStep(2);
      }
    }
  };

  async function createOtpStep1() {
    props.showAppLoader();
    try {
      const result = await props.createOtpLogin({
        phoneNumber: form.phone,
        sendAsTextToSpeech: false,
        configName: props.appName == 'fundial' ? 'OTP_FUNDIAL' : 'OTP_SALE',
      });

      if (result.payload?.ticketId) {
        return result.payload?.ticketId;
      }
    } catch (error) {
      console.info('createOtp', error);
      return null;
    } finally {
      props.hideAppLoader();
    }
  }

  async function createOtpStep1_OLD() {
    const captchaToken = await getRecaptchaToken('OtpVerifyPhonePage');

    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }

    props.showAppLoader();
    try {
      const result = await ProviderManager.getProviderData('createOtp', [form.phone, null, captchaToken, 'fundial']);
      if (result.Body && result.Body.step1Ticket) {
        return result.Body.step1Ticket;
      }
    } catch (error) {
      console.info('createOtp', error);
      return null;
    } finally {
      props.hideAppLoader();
    }
  }

  const clearPhone = () => {
    form.phone = '';
    setForm(form);
  };

  const validateStep1 = (e) => {
    const form = Object.assign({}, validateFields(e));
    setForm(form);
    if (!props.isDisplayIdentity && form.errors.id != '' && form.errors.phone == '') {
      return true;
    }

    return false;
  };

  const changeHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    const tmpForm = Object.assign({}, validateField(form, name, value));

    if (tmpForm.phone.length > 10) {
      tmpForm.phone = tmpForm.phone.slice(0, 10);
      tmpForm.errors.phone = '';
    }

    let isNumber = /^\d+$/.test(form.phone);

    if (tmpForm.phone.length < 10 && isNumber) tmpForm.errors.phone = '';

    setForm(tmpForm);
  };

  // step 2 -----------------------------------------------------------------------

  const clearCode = () => {
    form.verifyCode = '';
    setForm(form);
  };

  const addAttempt = () => {
    const tempForm = Object.assign({}, validateFields(form));
    tempForm.numOfAttempts = form.numOfAttempts + 1;
    setForm(tempForm);
  };

  const readyToCreateOtp = () => {
    if (form.numOfAttempts >= Config.verifyCodeAttemptsLimit) return;

    if (form.phone != null && form.phone != undefined) {
      props.showAppLoader();
      createOtp(false);
    }
  };

  const readyToCreateVoiceOtp = () => {
    if (form.numOfAttempts >= Config.verifyCodeAttemptsLimit) return;

    if (form.phone != null && form.phone != undefined) {
      props.showAppLoader();
      createOtp(true);
    }
  };

  const createOtp = async (isVoice) => {
    try {
      const result = await props.createOtpLogin({
        phoneNumber: form.phone,
        sendAsTextToSpeech: isVoice,
        configName: props.appName == 'fundial' ? 'OTP_FUNDIAL' : 'OTP_SALE',
      });

      if (result.payload?.ticketId) {
        setOtpTicketId(result.payload.ticketId);
        handleCodeChange('clear');
        clearCode();
      }
    } catch (error) {
      console.info('createOtp', error);
      return null;
    } finally {
      props.hideAppLoader();
      addAttempt();
    }
  };

  const handleCodeChange = (otp) => {
    const tempForm = Object.assign({}, form);
    tempForm.verifyCode = otp;
    setForm(tempForm);
  };

  async function checkOtp() {
    const isValidOtp = await validateOtp();
    if (isValidOtp.payload?.loginData?.isOtpAuthenticated) {
      props.onSuccess();
    }
    else {
      addAttempt();
      if (isValidOtp.error.message == "SUBSCRIBER_NUMBER_NOT_EXISTS") {
        setWrongOtpMessage(`רק רגע, אנחנו לא מזהים את המספר כמנוי ${window.Config.brand_Name_HE}.\n בדקו את המנוי שהוזן.`);
      }
      else {
        setWrongOtpMessage('הקוד שהוזן אינו תקין, נסה שנית');
      }
      return;
    }
  }

  async function validateOtp() {
    props.showAppLoader();
    try {
      const result = await props.validateOtpLogin({ code: form.verifyCode });
      return result;
    } catch (error) {
      let test = form;
      console.info('validateOtp', error);
      return false;
    } finally {
      props.hideAppLoader();
    }
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter') {
      if (otpTicketId != '' && props.currentStep == 2) {
        checkOtp();
      } else {
        getTicket();
      }
    }
  }

  let step1 = (
    <div className='otp-step1'>
      <div className='content'>
        {props.step1Title && (
          <Row>
            <Col ms={12}>
              <h1 className='title-small'>{props.step1Title}</h1>
            </Col>
          </Row>
        )}
        {props.step1SubTitle && (
          <Row>
            <Col ms={12}>
              <h2 className='title-big'>{props.step1SubTitle}</h2>
            </Col>
          </Row>
        )}
        {props.step1LinkText && (
          <Row>
            <Col ms={12}>
              <p className='title-small'>{props.step1LinkText}</p>
            </Col>
          </Row>
        )}
        <Row>
          <Col ms={12}>
            <div className='component-container'>
              {props.step1TopComment && <div className='comment'>{props.step1TopComment}</div>}
              <TextInput
                name='phone'
                type='number'
                pattern='[0-9]*'
                id='phone'
                maxLength='10'
                autoComplete='off'
                placeholder={props.placeholder ?? 'טלפון'}
                required='required'
                value={form.phone}
                error={form.errors.phone}
                onChange={(e) => changeHandler({ target: e.target, form: form })}
                onWheel={(e) => e.target.blur()}
                onKeyDown={handleKeyDown}
              />
              {props.step1BottomComment && <div className='comment'>{props.step1BottomComment}</div>}
              {props.isDisplayIdentity && (
                <TextInput
                  error={form.errors.id}
                  onChange={(e) => changeHandler({ target: e.target, form: form })}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={handleKeyDown}
                  value={form.id}
                  name='id'
                  maxLength='9'
                  pattern='[0-9]*'
                  type='number'
                  placeholder='תעודת זהות'
                  required='required'
                />
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div style={{ textAlign: 'center' }}>
              <BtnSubmit onclick={getTicket} text={props.step1ButtonText} />
            </div>
          </Col>
        </Row>
        {props.bottomLink != undefined && props.bottomText != '' && (
          <Row>
            <Col ms={12}>
              <br />
              <p className='bottom-text'>{props.step1BottomText}</p>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );

  let step2 = (
    <div className='container-fluid main'>
      <div className='shared-otp-code'>
        {props.step2Title && (
          <Row>
            <Col ms={12}>
              <h1 className='main-title'>{props.step2Title}</h1>
            </Col>
          </Row>
        )}
        {props.step2SubTitle && (
          <Row>
            <Col ms={12}>
              <h1 className='top-title'>{props.step2SubTitle}</h1>
            </Col>
          </Row>
        )}
        <Row>
          <Col ms={12}>
            <div className='component-container' style={{ backgroundColor: 'transparent' }}>
              <div className='mainDiv' onKeyDown={handleKeyDown}>
                <OtpInput
                  shouldAutoFocus={true}
                  value={form.verifyCode}
                  onChange={handleCodeChange}
                  numInputs={6}
                  isInputNum={true}
                  separator={<span className='inputSeparator'></span>}
                  inputStyle='input-design'
                  containerStyle='mainDivInside'
                  renderInput={(inputProps, index) => (
                    <input {...inputProps} key={index} autoComplete="one-time-code" />
                  )}
                />
              </div>

              {wrongOtpMessage != ''}
              <br />
              <div className='error-container'>
                <div className='error'>{wrongOtpMessage}</div>
              </div>

              {form.numOfAttempts >= Config.verifyCodeAttemptsLimit ? <div className='error'>לא ניתן לבצע ניסיונות נוספים</div> : ''}

              <section className='otp-btn-container'>
                <div role='button' tabIndex='0' onClick={readyToCreateOtp}>
                  <section className='otp-btn-container'>
                    <div>
                      <Image src={require('./images/sms.svg')} alt='לא קיבלתי קוד, שילחו לי שוב' />
                    </div>
                    <div>
                      <span>
                        הקוד לא הגיע, <br />
                        שלחו לי שוב
                      </span>
                    </div>
                  </section>
                </div>
                <div className='spacer'></div>
                <div role='button' tabIndex='1' onClick={readyToCreateVoiceOtp}>
                  <section className='otp-btn-container'>
                    <div>
                      <Image src={require('./images/voice.svg')} alt='שילחו לי קוד בהודעה קולית' />
                    </div>
                    <div>
                      <span>
                        שילחו לי קוד
                        <br />
                        בהודעה קולית
                      </span>
                    </div>
                  </section>
                </div>
              </section>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div style={{ textAlign: 'center' }}>
              <BtnSubmit onclick={checkOtp} text={props.step2ButtonText} />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );

  return <div>{otpTicketId != '' && props.currentStep == 2 ? step2 : step1}</div>;
};

const mapStateToProps = (state) => {
  return {
    form: state.otpVerifyCode.form,
    currentStep: state.otp.currentStep,
  };
};

const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader,
  otpReportStep,
  createOtpLogin,
  validateOtpLogin,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginOtp);
